import { useRef, useEffect, useState } from "react";

// Components
import Button from "../button/button";
import IconFA from "../icon-fa/icon-fa";

// Style
import style from "./modal.module.scss";

export default function Modal({ setShowModal, popupData }) {
  const { ptTermsFields, btn } = popupData;
  const coords = btn.getBoundingClientRect();
  const coordX = coords.left + window.scrollX + coords.width / 2;
  const coordY = coords.top + window.scrollY - 54;
  const [content, setContent] = useState("");

  function closeModal() {
    btn.focus();
    btn.ariaExpanded = false;
    setShowModal(false);
  }

  function handleKeyPress(e) {
    if (e.key === "Escape" || e.key === "Enter") {
      e.preventDefault();
      closeModal();
    } else if (e.key === "Tab") {
      e.preventDefault();
      document.getElementById("modal-close").focus();
    }
  }

  const ref = useRef(null);
  useEffect(() => {
    const handleOutSideClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!ref.current?.contains(e.target)) {
        closeModal();
      }
    };
    window.addEventListener("click", handleOutSideClick);
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("click", handleOutSideClick);
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [ref]);

  useEffect(() => {
    var div = document.createElement("div");
    div.innerHTML = ptTermsFields?.popupDescription;
    const elements = div.getElementsByTagName("em");
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    setContent(div.innerHTML);
    // console.log(content);
  }, [ptTermsFields]);

  return (
    <>
      <div id={"term-modal"} className={style.overlay} />
      <div
        className={style.modal}
        ref={ref}
        style={{ left: coordX, top: coordY }}
      >
        <div className={style.labelContainer}>
          <h3 className={style.label}>
            {ptTermsFields?.popupLabel ?? popupData.title}
          </h3>
          <Button id="modal-close" onClick={() => closeModal()}>
            <IconFA name="thinX" color="white" />
          </Button>
        </div>
        <hr className={style.divider} />
        <div
          className={style.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </>
  );
}
